import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { DayforceAgenciesProvider } from '../shared/context/DayforceAgenciesProvider'
import { JobDetails } from '../shared/components/JobDetails/JobDetails'
import * as ROUTES from 'constants/routes'
import { Box } from '@workwhile/ui'
import { Header } from 'components/Header'

export const DayforceJobDetail = () => {
  const { agencyId, jobId } = useParams<{ agencyId: string; jobId: string }>()

  if (!agencyId || !jobId) {
    return <Navigate to={ROUTES.DAYFORCE_WEBHOOKS} replace />
  }

  return (
    <DayforceAgenciesProvider>
      <Header title="Dayforce Job" subTitle={jobId} />
      <Box margin={3}>
        <JobDetails agencyId={agencyId} jobId={jobId} />
      </Box>
    </DayforceAgenciesProvider>
  )
}
